<div *ngIf="version!==2" class="donor-content">
  <div class="flex-container-row">
    <div class="donor-img-container">
      <span *ngIf="!donorObject?.avtar && !isDefaultUser" class="donor-img-placeholder">{{donorObject?.initials| uppercase}}</span>
      <i *ngIf="isDefaultUser" class="icon-user1"></i>
      <img loading="lazy" class="donor-img" [hidden]="!(donorObject?.avtar && !isDefaultUser)" [attr.data-src]="cdn?.match('anonymous')? '/assets/images/anonymous.png' : cdn" [alt]="'Donor - ' + donorObject?.name" />
    </div>
    <div class="donor-date donor-name-container">
      <span class="d-name">
        <span class="donor-title" *ngIf="title">{{title}}</span>
        <span class="donor-name align-middle">{{donorObject?.name}}</span>
      </span>
      <div *ngIf="showTime && donorObject?.creation_date" class="donor-date date-time">{{donorObject?.creation_date | dayjs:'to'}}</div>
    </div>
  </div>
  <div *ngIf="donorObject?.donated_amount && donor" class="donor-amt">
    <!-- <mat-icon *ngIf="donorObject.currencyInfo.is_symbol" class="donor-icon" [ngClass]="donorObject.currencyInfo.icon"></mat-icon>
    <span *ngIf="!donorObject.currencyInfo.is_symbol">{{donorObject.currencyInfo.icon}}</span> -->
    <app-currency-icon *ngIf="donor?.iso_currency" [currency]="donor?.iso_currency"></app-currency-icon>
    {{(donorObject?.donated_amount || donorObject?.raised) | inrFormat:donor?.iso_currency}}
  </div>
</div>

<div *ngIf="version===2" class="donorWrap">
  <div class="content">
    <div class="listWrap">
      <div class="logo">
        <span *ngIf="!donorObject?.avtar && !isDefaultUser" class="donorImgPlaceholder">{{donorObject?.initials| uppercase}}</span>
        <i *ngIf="isDefaultUser" class="icon-user1"></i>
        <img loading="lazy" [hidden]="!(donorObject?.avtar && !isDefaultUser)" [attr.data-src]="cdn?.match('anonymous')? '/assets/images/anonymous.png' : cdn" [alt]="'Donor - ' + donorObject?.name" />
      </div>
      <div class="details">
        <div class="donorName">{{donorObject?.name}}</div>
        <div *ngIf="donorObject?.product_sales?.length" class="desc">
          {{donorObject?.product_sales[0]?.unit_count > 1 ? donorObject?.product_sales[0]?.unit_count : ''}} {{donorObject?.product_sales[0]?.campaign_product?.product?.name}}{{donorObject?.product_sales[0]?.unit_count > 1 ? 's' : ''}} {{donorObject?.product_sales?.length > 1 ? '+ ' + (donorObject?.product_sales?.length - 1) + (donorObject?.product_sales?.length > 2 ? ' items' : ' item'): ''}}
          <div *ngIf="donorObject?.product_sales?.length > 1" class="kartInfo">
            <em class="material-icons">info_outline</em>
            <div class="kartList">
              <ul>
                <li *ngFor="let item of donorObject?.product_sales">{{item?.unit_count}} {{item?.campaign_product?.product?.name}}{{item?.unit_count > 1 ? 's' : ''}} - <app-currency-icon [currency]="item?.currency" />{{item?.donated_amount | inrFormat:item?.currency}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="donor?.iso_currency" class="amount">
        <app-currency-icon [currency]="donor?.iso_currency" />{{(donorObject?.donated_amount || donorObject?.raised) | inrFormat:donor?.iso_currency}}
      </div>
    </div>
  </div>
</div>